/**
 * Import dependencies.
 */
import $ from 'jquery';
import { els } from './variables';

// Closing the notice for the Coronovirus banner
const initSiteNotice = function () {
	console.log('initializing initSiteNotice()');
	if (document.cookie.indexOf('site-notice__optout') === -1) {
		$('.notice-close').parent().parent().show();
	}

	// setting up the notice closer for coronavirus
	$('.notice-close').on('click', function () {
		document.cookie = 'site-notice__optout=true;path=/';
		$(this).parent().parent().slideToggle();
		if (els.labAnchor) {
			els.labAnchor.classList.remove('banner-padding');
		}
	});
};

window.addEventListener('DOMContentLoaded', () => {
	initSiteNotice();
});
